import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { getFirestore, collection, addDoc, onSnapshot, updateDoc, deleteDoc, doc, query, orderBy } from 'firebase/firestore'; // needed

const StudentTimeTable = () => {
  const [timetable, setTimetable] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ class: '', section: '', day: 'Monday', time: '', outTime: '', subject: '', teacher: '' });
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  useEffect(() => {
    const db = getFirestore();
    const q = query(collection(db, 'studentTimeTable'), orderBy('class'), orderBy('section'), orderBy('day'));
    const unsub = onSnapshot(q, (snapshot) => {
      setTimetable(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  const handleShow = (entry = null) => {
    if (entry) {
      setEditId(entry.id);
      setForm({ class: entry.class, section: entry.section, day: entry.day, time: entry.time, outTime: entry.outTime || '', subject: entry.subject, teacher: entry.teacher });
    } else {
      setEditId(null);
      setForm({ class: '', section: '', day: 'Monday', time: '', outTime: '', subject: '', teacher: '' });
    }
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const db = getFirestore();
    if (editId) {
      await updateDoc(doc(db, 'studentTimeTable', editId), form);
    } else {
      await addDoc(collection(db, 'studentTimeTable'), form);
    }
    handleClose();
  };

  const handleDelete = async (id) => {
    const db = getFirestore();
    await deleteDoc(doc(db, 'studentTimeTable', id));
  };

  return (
    <div style={{padding: 0}}>
      <h2 style={{ fontWeight: 700, marginBottom: 24 }}>Student Time Table (Real-Time, Editable)</h2>
      <Button variant="primary" style={{ marginBottom: 16 }} onClick={() => handleShow()}>Add Entry</Button>
      <Card style={{ borderRadius: 16, boxShadow: '0 4px 24px rgba(25,118,210,0.10)', marginBottom: 24 }}>
        <Card.Body>
          <Table responsive hover size="sm" style={{ background: '#fff', borderRadius: 10, fontSize: 16 }}>
            <thead>
              <tr style={{ background: '#f5f7fa' }}>
                <th>Class</th>
                <th>Section</th>
                <th>Day</th>
                <th>Time</th>
                <th>Out Time</th>
                <th>Subject</th>
                <th>Teacher</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {timetable.map((row, i) => (
                <tr key={row.id}>
                  <td>{row.class}</td>
                  <td>{row.section}</td>
                  <td>{row.day}</td>
                  <td>{row.time}</td>
                  <td>{row.outTime || '--'}</td>
                  <td>{row.subject}</td>
                  <td>{row.teacher}</td>
                  <td>
                    <Button size="sm" variant="warning" onClick={() => handleShow(row)} style={{marginRight:8}}>Edit</Button>
                    <Button size="sm" variant="danger" onClick={() => handleDelete(row.id)}>Delete</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit' : 'Add'} Time Table Entry</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="g-2">
              <Col md={6}><Form.Group><Form.Label>Class</Form.Label><Form.Control name="class" value={form.class} onChange={handleChange} required /></Form.Group></Col>
              <Col md={6}><Form.Group><Form.Label>Section</Form.Label><Form.Control name="section" value={form.section} onChange={handleChange} required /></Form.Group></Col>
            </Row>
            <Row className="g-2 mt-2">
              <Col md={4}><Form.Group><Form.Label>Day</Form.Label><Form.Select name="day" value={form.day} onChange={handleChange}>{days.map(d => <option key={d}>{d}</option>)}</Form.Select></Form.Group></Col>
              <Col md={4}><Form.Group><Form.Label>Time</Form.Label><Form.Control name="time" value={form.time} onChange={handleChange} required placeholder="08:00-09:00" /></Form.Group></Col>
              <Col md={4}><Form.Group><Form.Label>Out Time</Form.Label><Form.Control name="outTime" value={form.outTime} onChange={handleChange} required placeholder="09:00" /></Form.Group></Col>
            </Row>
            <Row className="g-2 mt-2">
              <Col md={6}><Form.Group><Form.Label>Subject</Form.Label><Form.Control name="subject" value={form.subject} onChange={handleChange} required /></Form.Group></Col>
              <Col md={6}><Form.Group><Form.Label>Teacher</Form.Label><Form.Control name="teacher" value={form.teacher} onChange={handleChange} required /></Form.Group></Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="primary" type="submit">{editId ? 'Update' : 'Add'}</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default StudentTimeTable;
